<script lang="ts" setup>
import { useTransition } from '../shared/composables/transition';
import type { TransitionProps } from '../types';

const props = defineProps<TransitionProps>();

const { classProps, componentIs, componentProps } = useTransition(() => props, {
  active: 'motion-safe:transition-[opacity,scale]',
  hidden: 'scale-[1_-1] opacity-0',
});
</script>

<template>
  <component v-bind="{ ...classProps, ...componentProps, ...$attrs }" :is="componentIs">
    <slot></slot>
  </component>
</template>
